export const REMOTE_URL = "";
export const GET_DEPT_URL = "/api/v1/currencies";
export const ADD_DEPT_URL = "/api/v1/currencies/create";
export const UPD_DEPT_URL = "/api/v1/currencies/update";
